import React, { memo } from 'react';
import { Grid, Theme } from '@material-ui/core';
import { withStyles, WithStyles, createStyles } from '@material-ui/core/styles';

import { FormattedMessage, useIntl } from 'react-intl';
import { ActionModal } from '../../../components/Modal';
import { Typography } from '../../../components/Typography';

const styles = (theme: Theme) => {
  return createStyles({
    userCard: {},
    right: {
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'column',
    },
  });
};

export interface IUserInfoModalProps extends WithStyles<typeof styles> {
  selectedUser: any;
  open: boolean;
  handleClose: () => void;
}

const UserInfoModal = ({
  classes,
  selectedUser,
  open,
  handleClose,
}: IUserInfoModalProps) => {
  const intl = useIntl();

  const getStatus = (status: string) => {
    if (status === 'active') {
      return intl.formatMessage({
        id: 'active',
      });
    }
    if (status === 'suspend') {
      return intl.formatMessage({
        id: 'suspend_simple',
      });
    }
    return 'none';
  };

  return (
    <ActionModal
      modalTitle={selectedUser?.profile?.name}
      open={open}
      handleClose={handleClose}
      actinButtonLabel={intl.formatMessage({
        id: 'done',
      })}
      actinButtonOnClick={handleClose}
      isSingleButton
    >
      <Grid container className={classes.userCard}>
        <Grid item className={classes.right}>
          <Typography variant="body1" color="secondary">
            <FormattedMessage id="email" /> :&nbsp;
            {selectedUser?.email}
          </Typography>
          <Typography variant="body1" color="secondary">
            <FormattedMessage id="status" /> :&nbsp;
            {getStatus(selectedUser?.status)}
          </Typography>
        </Grid>
      </Grid>
    </ActionModal>
  );
};

export default memo(withStyles(styles)(UserInfoModal));
